export const menuSorter = (menu, landingMenu) =>
  landingMenu.reduce((acc, { shortName, slug }) => {
    acc[acc.findIndex(el => el.slug === slug)] = {
      name: shortName,
      link: `/landing/${slug}`,
      slug,
    };
    return acc;
  }, menu);
